import { TUIModel } from './../../UIBuilder/ui.d';
import { TClassProject, TransferModelOwnerPayload, TPushToEnvironmentPayload, TEnvironmentOption, TUpsertISRProjectDataModelsInput1 } from './../model.d';
import ServiceWrapper from "Services/ServiceWrapper";
import AppSettings from "Settings/AppSettings";
import AuthManager from "Common/AuthManager";
import { TPaginationParams } from 'Pages/GMS/Performance/analytics';
import { toast } from 'Components/DesignSystem/Toast/useToast';

const CREATE_ISR_END_POINT = 'isr/upsert_data_models';
const CREATE_GUIDE_END_POINT = 'guide/upsert_data_models';
const CREATE_UI_MODEL_END_POINT = 'isr/define_ui';
const FETCH_PRODUCTS_END_POINT = "isr/products";
const PROMOTION_END_POINT: string = 'isr/manage_delta_states';
const BASE_URL = AppSettings.GMS_BACKEND_API_URL;

export const createProject = async (payload: TUpsertISRProjectDataModelsInput1, isGuide: boolean) => {
    try {
        const endPoint = isGuide ? CREATE_GUIDE_END_POINT : CREATE_ISR_END_POINT;
        const response = await ServiceWrapper.doPost(
            BASE_URL + endPoint,
            payload,
            null,
            AuthManager.getGmsToken()
        );
        return response?.data;
    } catch (e) {
        return null;
    }
}

export const createUIMOdel = async (payload: TUIModel) => {
    try {
        const response = await ServiceWrapper.doPost(
            BASE_URL + CREATE_UI_MODEL_END_POINT,
            payload,
            null,
            AuthManager.getGmsToken()
        );
        return response?.data;
    } catch (e) {
        return null;
    }
}

export const getUIModels = async (projectId: string) => {
    const response = await ServiceWrapper.doGet(
        BASE_URL + `isr/ui_definitions/${projectId}`,
        null,
        null,
        AuthManager.getGmsToken()
    );
    try {
        return response?.data;
    } catch (error) {
        console.log('Error', error);
        return null;
    }
}

export const getISRProjects = async (isGuide: boolean, industryId: string, channelId: string, paginationParams: TPaginationParams, sortBy: string = 'updatedAt', sortOrder: string = 'desc', search: string = '') => {
    try {
        const searchParam = search?.trim() ? `&search=${encodeURIComponent(search.trim())}` : '';
        const endPoint = isGuide ? `guide/projects/${industryId}/${channelId}?page=${paginationParams.pageNumber}&limit=${paginationParams.pageSize}&sort_by=${sortBy}&sort_order=${sortOrder}${searchParam}` : `isr/projects/${industryId}/${channelId}?page=${paginationParams.pageNumber}&limit=${paginationParams.pageSize}&sort_by=${sortBy}&sort_order=${sortOrder}${searchParam}`;
        const response = await ServiceWrapper.doGet(
            BASE_URL + endPoint,
            null,
            null,
            AuthManager.getGmsToken()
        );
        return response?.data;
    } catch (error) {
        console.log('Error', error);
        return null;
    }
}

export const getISRProjectsForAnalytics = async (industryId: string, channelId: string) => {
    try {
        const endPoint = `analytics/isr/projects/${industryId}/${channelId}`;
        const response = await ServiceWrapper.doGet(
            BASE_URL + endPoint,
            null,
            null,
            AuthManager.getGmsToken()
        );
        return response?.data;
    } catch (error) {
        console.log('Error', error);
        return null;
    }
}

export const getISRProject = async (projectId: string) => {
    const response = await ServiceWrapper.doGet(
        BASE_URL + `isr/project/${projectId}`,
        null,
        null,
        AuthManager.getGmsToken()
    );
    try {
        return response?.data;
    } catch (error) {
        console.log('Error', error);
        return null;
    }
}

export const getCategoryTypeAndCategory = async (industryId: string,) => {
    let response = await ServiceWrapper.doGet(
        `${BASE_URL}industry/${industryId}/categorytype/category`,
        null,
        null,
        AuthManager.getGmsToken()
    );

    try {
        return response?.data;
    } catch (e) {
        console.log('Error', e);
        return null;
    }
}

export const getCategoryBasedProducts = async (categoryId: string) => {
    const response = await ServiceWrapper.doGet(
        BASE_URL + `${FETCH_PRODUCTS_END_POINT}/${categoryId}`,
        null,
        null,
        AuthManager.getGmsToken()
    );
    try {
        return response?.data;
    } catch (error) {
        console.log('Error', error);
        return null;
    }
}

export const getAttributeBasedProducts = async (attributeId: string) => {
    const response = await ServiceWrapper.doGet(
        BASE_URL + `${FETCH_PRODUCTS_END_POINT}/${attributeId}`,
        null,
        null,
        AuthManager.getGmsToken()
    );
    try {
        return response?.data;
    } catch (error) {
        console.log('Error', error);
        return null;
    }
}

export const getAssociatedAttributes = async (categoryId: string) => {

    const response = await ServiceWrapper.doGet(
        BASE_URL + `isr/attributes/${categoryId}`,
        null,
        null,
        AuthManager.getGmsToken()
    );
    try {
        return response?.data;
    } catch (error) {
        console.log('Error', error);
        return null;
    }
}

export const getAllLists = async (industryId: string) => {

    const response = await ServiceWrapper.doGet(
        BASE_URL + `isr/${industryId}/lists`,
        null,
        null,
        AuthManager.getGmsToken()
    );
    try {
        return response;
    } catch (error) {
        console.log('Error', error);
        return null;
    }
}

export const getAllAttributes = async (industryId: string) => {

    const response = await ServiceWrapper.doGet(
        BASE_URL + `isr/${industryId}/attributes`,
        null,
        null,
        AuthManager.getGmsToken()
    );
    try {
        return response?.data;
    } catch (error) {
        console.log('Error', error);
        return null;
    }
}

export const getAttributeValues = async (attributeId: string) => {
    const limit = 100000; // Set your desired limit
    const skip = 0;      // Set your desired skip value

    const response = await ServiceWrapper.doGet(
        BASE_URL + `isr/attribute/${attributeId}/attributevalues/list?limit=${limit}&skip=${skip}`,
        null,
        null,
        AuthManager.getGmsToken()
    );

    try {
        return response?.data;
    } catch (error) {
        console.log('Error', error);
        return null;
    }
}


export const promoteISR = async (productId: string, uiModelIds: string[]) => {
    const response = await ServiceWrapper.doPut(
        BASE_URL + PROMOTION_END_POINT,
        {
            "project_id": productId ?? '',
            "action": "publish",
            "uimodel_ids": uiModelIds
        },
        null,
        AuthManager.getGmsToken()
    );
    try {
        return response?.data;
    } catch (e) {
        console.log(e, "error");
        return null;
    }
}

export const deleteISR = async (projectId: string) => {
    const response = await ServiceWrapper.doDelete(
        BASE_URL + `isr/delete_project/${projectId}`,
        null,
        null,
        AuthManager.getGmsToken()
    );
    try {
        return response?.data;
    } catch (e) {
        console.log(e, "error");
        return null;
    }
}

export const promoteProductData = async (industryId: string, categories: []) => {
    const response = await ServiceWrapper.doPut(
        BASE_URL + `isr/sync_isr_delta_data`,
        { industry: industryId, category_ids: categories },
        null,
        AuthManager.getGmsToken()
    );
    try {
        return response?.data;
    } catch (e) {
        console.log(e, 'error');
        return null;
    }
}

export const createClass = async (payload: TClassProject) => {
    const response = await ServiceWrapper.doPost(
        BASE_URL + '/isr/create_class',
        payload,
        null,
        AuthManager.getGmsToken()
    );
    try {
        return response?.data;
    } catch (e) {
        return null;
    }
}

export const checkJobStatus = async (jobId: String, previousToastId: any, onComplete?: () => void) => {
    try {
        const statusResponse = await ServiceWrapper.doGet(`${BASE_URL}job/status/${jobId}`, null, null, AuthManager.getGmsToken());

        if (!statusResponse.errorfound) {
            const { data } = statusResponse;

            // § 100: toastify's update-by-id becomes the DS store's
            // replace-in-place — same id, new tone/title.
            if (data?.error) {
                toast.error(data.status ?? '', { id: previousToastId });
                return;
            }

            if (data?.processing) {
                toast.info('SB3 Promotion in progress ...', { id: previousToastId, duration: null });
                setTimeout(() => { checkJobStatus(jobId, previousToastId, onComplete); }, 2000);
                return;
            }
            toast.success('SB3 Promotion completed', { id: previousToastId, duration: 2000 });
            onComplete?.();
        }
    } catch (error) {
        toast.error("Error occurred while checking job status. Please try again.");
    }
};

export const getAllProjectClass = async (projectId: string) => {
    const response = await ServiceWrapper.doGet(
        BASE_URL + `isr/classes/${projectId}`,
        null,
        null,
        AuthManager.getGmsToken()
    );
    try {
        return response?.data;
    } catch (error) {
        console.log('Error', error);
        return null;
    }
}

export const deleteClass = async (projectId: string, classId: string) => {
    const response = await ServiceWrapper.doDelete(
        BASE_URL + `isr/delete_class/${projectId}/${classId}`,
        null,
        null,
        AuthManager.getGmsToken()
    );
    try {
        return response?.data;
    } catch (e) {
        console.log(e, "error");
        return null;
    }
}

// isr/update_class
export const updateClass = async (payload: TClassProject) => {
    const response = await ServiceWrapper.doPut(
        BASE_URL + `isr/update_class`,
        payload,
        null,
        AuthManager.getGmsToken()
    );
    try {
        return response?.data;
    } catch (e) {
        console.log(e, 'error');
        return null;
    }
}

export const getIndustryCategoriesData = async (industryId: string) => {
    const response = await ServiceWrapper.doGet(
        BASE_URL + `isr/categories/${industryId}`,
        null,
        null,
        AuthManager.getGmsToken()
    );
    try {
        return response?.data;
    } catch (e) {
        console.log(e, "error");
        return null;
    }
}

export const getIndustryChannelCategoriesData = async (industryId: string, channelKey: string) => {
    const response = await ServiceWrapper.doGet(
        BASE_URL + `isr/categories/industry/${industryId}/channel/${channelKey}`,
        null,
        null,
        AuthManager.getGmsToken()
    );
    try {
        return response?.data;
    } catch (e) {
        console.log(e, "error");
        return null;
    }
}

export const getMerchantConfigData = async (channelKey: string) => {
    const response = await ServiceWrapper.doGet(
        BASE_URL + `isr/merchant/config/${channelKey}`,
        null,
        null,
        AuthManager.getGmsToken()
    );
    try {
        return response?.data;
    } catch (e) {
        console.log(e, "error");
        return null;
    }
}

export const updateMerchantConfigData = async (channelKey: string, merchantConfigData: { config_attr: any; value: any }[]) => {
    const response = await ServiceWrapper.doPut(
        BASE_URL + `isr/merchant/config/${channelKey}`,
        merchantConfigData,
        null,
        AuthManager.getGmsToken()
    );
    try {
        return response?.data;
    } catch (e) {
        console.log(e, "error");
        return null;
    }
}
export const transferModelOwner = async (data: TransferModelOwnerPayload) => {
    try {
        const res = await ServiceWrapper.doPut(
            `${BASE_URL}isr/transfer_ownership`,
            data,
            null,
            AuthManager.getGmsToken()
        );
        if (res?.data?.done)
            return res;
    } catch (error) {
        return null
    }
};

export const copyModel = async (modelId: string, modelName?: string) => {
    try {
        const res = await ServiceWrapper.doPost(
            `${BASE_URL}guide/clone_model/${modelId}`,
            modelName ? { model_name: modelName } : null,
            null,
            AuthManager.getGmsToken()
        );
        return res;
    } catch (error) {
        return null
    }
};

export const getRecommenderModelsForGuide = async (channelKey: string, base_categories?: string[], target_categories?: string[]) => {
    try {
        const params = new URLSearchParams({});
        if (base_categories && base_categories.length > 0) params.append('base_categories', JSON.stringify(base_categories));
        if (target_categories && target_categories.length > 0) params.append('target_categories', JSON.stringify(target_categories));

        const endpoint = `${BASE_URL}guide/channel/${channelKey}/recommender_model?${params.toString()}`;
        let res = await ServiceWrapper.doGet(
            endpoint,
            null,
            null,
            AuthManager.getGmsToken()
        );

        if (!res.errorfound) {
            return res.data;
        } else return null;
    } catch (error) {
        console.error("Error fetching recommender model data:", error);
        return null;
    }
};

export const uploadProductModel = async (file: File, channelKey: string) => {
    try {
        const formData = new FormData();
        formData.append('file', file);

        const response = await ServiceWrapper.doPost(
            `${BASE_URL}override-mappings/upload/${channelKey}`,
            formData,
            null,
            AuthManager.getGmsToken(),
            true
        );
        return response?.data;
    } catch (e) {
        return null;
    }
};

export async function loadAttributes(category_ids: string[], data_types: string[], page: number, limit: number, search_key: string = '') {
    let res = await ServiceWrapper.doPost(
        `${BASE_URL}get_attributes?page=${page}&limit=${limit}&search=${search_key}`,
        { category_ids: category_ids, data_types: data_types },
        null,
        AuthManager.getGmsToken()
    );

    return [res.errorfound ?? true, res?.data ?? null]
}

export const getEnvironmentsForChannel = async (channelKey: string): Promise<TEnvironmentOption[]> => {
    try {
        const res = await ServiceWrapper.doGet(
            `${BASE_URL}guide/channel/${channelKey}/environments`,
            null,
            null,
            AuthManager.getGmsToken()
        );
        return res?.data?.environments ?? [];
    } catch (error) {
        return [];
    }
};

export const getModelsForEnvironment = async (envKey: string, industryId: string): Promise<TEnvironmentOption[]> => {
    try {
        const res = await ServiceWrapper.doGet(
            `${BASE_URL}guide/projects/${industryId}/${envKey}`,
            null,
            null,
            AuthManager.getGmsToken()
        );
        return (res?.data?.data ?? []).map((m: any) => ({ value: m.id, label: m.ISRName }));
    } catch (error) {
        return [];
    }
};

export const pushModelToEnvironment = async (payload: TPushToEnvironmentPayload): Promise<{ done: boolean; message?: string }> => {
    try {
        const res = await ServiceWrapper.doPost(
            `${BASE_URL}guide/push_model`,
            payload,
            null,
            AuthManager.getGmsToken()
        );
        return res?.data ?? { done: false };
    } catch (error) {
        return { done: false, message: 'An unexpected error occurred' };
    }
};

export const listWidgets = async (industry: string, channel: string) => {
    try {
        const response = await ServiceWrapper.doGet(
            `${BASE_URL}guide/widgets/${industry}/${channel}`,
            null, null, AuthManager.getGmsToken()
        );
        return response?.data;
    } catch (e) { return null; }
};

export const createWidget = async (payload: { title: string; model_id: string; channel: string; industry: string }) => {
    try {
        const response = await ServiceWrapper.doPost(
            `${BASE_URL}guide/widget`,
            payload,
            null, AuthManager.getGmsToken()
        );
        return response?.data;
    } catch (e) { return null; }
};

export const updateWidget = async (widgetId: string, payload: { title?: string; model_id?: string }) => {
    try {
        const response = await ServiceWrapper.doPut(
            `${BASE_URL}guide/widget/${widgetId}`,
            payload,
            null, AuthManager.getGmsToken()
        );
        return response?.data;
    } catch (e) { return null; }
};

export const deleteWidget = async (widgetId: string) => {
    try {
        const response = await ServiceWrapper.doDelete(
            `${BASE_URL}guide/widget/${widgetId}`,
            null, null, AuthManager.getGmsToken()
        );
        return response?.data;
    } catch (e) { return null; }
};

export const getPromotedModelsForWidget = async (industry: string, channel: string, excludeWidgetId?: string) => {
    try {
        const url = excludeWidgetId
            ? `${BASE_URL}guide/widgets/promoted-models/${industry}/${channel}?exclude_widget_id=${excludeWidgetId}`
            : `${BASE_URL}guide/widgets/promoted-models/${industry}/${channel}`;
        const response = await ServiceWrapper.doGet(url, null, null, AuthManager.getGmsToken());
        return response?.data;
    } catch (e) { return null; }
};

/**
 * Bulk-marks every unviewed Widget in a channel as viewed (ADO #14217 US-4
 * AC 2) — called when the Embed code dialog opens, clearing the New tags and
 * the update dot. NOT called on copy.
 */
export const markWidgetsViewed = async (industry: string, channel: string) => {
    try {
        const response = await ServiceWrapper.doPut(
            `${BASE_URL}guide/widgets/${industry}/${channel}/viewed`,
            {},
            null, AuthManager.getGmsToken()
        );
        return response?.data;
    } catch (e) { return null; }
};

/**
 * The Site code tab's persisted per-channel defaults — Platform, Identifier
 * mode, Catalog endpoint (ADO #14218 US-5 AC 1). A channel with nothing saved
 * yet still returns 200 with the dialog's own defaults, not an error.
 */
export const getChannelEmbedSettings = async (industry: string, channel: string) => {
    try {
        const response = await ServiceWrapper.doGet(
            `${BASE_URL}guide/embed-settings/${industry}/${channel}`,
            null, null, AuthManager.getGmsToken()
        );
        return response?.data;
    } catch (e) { return null; }
};

/**
 * Upserts any subset of Platform / Identifier mode / Catalog endpoint for a
 * channel. Each field is independently optional — send only what changed.
 */
export const updateChannelEmbedSettings = async (
    industry: string,
    channel: string,
    payload: { platform?: string; identifier_mode?: string; catalog_endpoint?: string }
) => {
    try {
        const response = await ServiceWrapper.doPut(
            `${BASE_URL}guide/embed-settings/${industry}/${channel}`,
            payload,
            null, AuthManager.getGmsToken()
        );
        return response?.data;
    } catch (e) { return null; }
};

export const bulkDeleteISRProjects = async (projectIds: string[], channelKey: string) => {
    try {
        const res = await ServiceWrapper.doPost(
            `${BASE_URL}isr/bulk_delete_projects`,
            { project_ids: projectIds, channel_key: channelKey },
            null, AuthManager.getGmsToken()
        );
        return res;
    } catch (e) { return null; }
};

export const bulkTransferModelOwner = async (modelIds: string[], userid: string, username: string, channelKey: string) => {
    try {
        const res = await ServiceWrapper.doPut(
            `${BASE_URL}isr/bulk_transfer_ownership`,
            { model_ids: modelIds, userid, username, channel_key: channelKey },
            null, AuthManager.getGmsToken()
        );
        return res;
    } catch (e) { return null; }
};

export const bulkApplyCSS = async (modelIds: string[], css: string, mode: 'overwrite' | 'append', channelKey: string) => {
    try {
        const res = await ServiceWrapper.doPost(
            `${BASE_URL}isr/bulk_apply_css`,
            { model_ids: modelIds, css, mode, channel_key: channelKey },
            null, AuthManager.getGmsToken()
        );
        return res;
    } catch (e) { return null; }
};
